<template>
    <nav class="kb-desktop-navigation-items" role="navigation">
        <ul class="kb-desktop-navigation-items__mainmenulist">
            <li v-for="item in items" v-bind:key="item.linkText" class="kb-desktop-navigation-items__mainmenuitem">
                <kb-base-link :href="item.url" class="kb-desktop-navigation-items__mainmenulink jt-header-navi-main" :link-props="{title: item.linkText,  target: item.target}">{{ item.linkText }}</kb-base-link>
                <ul v-if="item.children" class="kb-desktop-navigation-items__submenulist" aria-label="submenu">
                    <li v-bind:key="subitem.linkText" v-for="subitem in item.children" class="kb-desktop-navigation-items__submenuitem">
                        <kb-base-link :href="subitem.url" class="kb-desktop-navigation-items__submenulink jt-header-navi-sub" :link-props="{title: subitem.linkText,  target: subitem.target}">{{ subitem.linkText }}</kb-base-link>
                    </li>
                </ul>
            </li>

            <li v-for="profileItem in profileItems" v-bind:key="profileItem.linkText" class="kb-desktop-navigation-items__mainmenuitem">
                <kb-base-link :href="profileItem.url" class="kb-desktop-navigation-items__mainmenulink jt-header-navi-main">{{ profileItem.linkText }}</kb-base-link>
                <ul v-if="profileItem.children" class="kb-desktop-navigation-items__submenulist" aria-label="submenu">
                    <li v-bind:key="subitem.linkText" v-for="subitem in profileItem.children" class="kb-desktop-navigation-items__submenuitem">
                        <kb-base-link :href="subitem.url" class="kb-desktop-navigation-items__submenulink jt-header-navi-sub" :link-props="{title: subitem.linkText}">{{ subitem.linkText }}</kb-base-link>
                    </li>
                </ul>
            </li>
        </ul>

        <div class="kb-desktop-navigation-items__appendix">
            <kb-base-link :href="recipeUploadUrl" class="kb-desktop-navigation-items__appendixlink jt-header-navi-main" :link-props="{title: 'Rezept / Tipp hochladen'}">
                <kb-base-icon icon="toque" class="kb-desktop-navigation-items__appendixicon" />Rezept / Tipp hochladen
            </kb-base-link>
        </div>
    </nav>
</template>

<script>
import BaseLink from '@/components/Atoms/BaseLink/BaseLink'

export default {
    name: 'kb-desktop-navigation-items',
    props: {
        items: {
            required: true,
            type: Array
        },
        profileItems: {
            required: true,
            type: Array
        },
        recipeUploadUrl: {
            required: true,
            type: String
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/_colors';

.kb-desktop-navigation-items {

    width: 100%;
    height: 41px;
    border-radius: 4px;
    background: $cPrimary;

    .kb-base-link {
        outline: none;
        white-space: nowrap;
        cursor: pointer;
    }

    &__mainmenulist {
        list-style: none;
        margin: 0;
        padding: 6px 0 0 .5rem;
    }

    &__mainmenuitem  {
        position: relative;
        display: block;
        float:left;
        transition-duration: 0.5s;
    }

    &__mainmenuitem:hover,
    &__mainmenuitem:focus-within {
        cursor: pointer;
    }

    &__mainmenulink {
        display: block;
        float: left;
        padding: 3px 12px 9px 12px;
        position: relative;
        text-decoration: none;
        transition-duration: 0.5s;
        color: #ffffff;
        background: $cPrimary;
        font-family: $fontFamilyRegular;
        font-size: 18px;
        line-height: 22px;
        border-radius: 4px 4px 0 0;
        border-color: $cPrimary;
        border-width: 1px 1px 0 1px;
        border-style: solid;
    }

    &__mainmenuitem:hover &__mainmenulink {
        background: $cBGPrimary;
        color: $cPrimary;
    }

    &__submenulist {
        background: $cBGPrimary;
        border-radius: 0 0 4px 4px;
        border-color: $cPrimary;
        border-width: 0 1px 1px 1px;
        border-style: solid;
        visibility: hidden;
        opacity: 0;
        min-width: 10rem;
        position: absolute;
        transition: all 0.5s ease;
        margin-top: 35px;
        left: 0;
        display: none;
        list-style: none;
        padding: .5rem 0 .5rem 0;
        z-index: 99998;
    }

    &__submenuitem {
        position: relative;
        float:left;
        display: block;
        clear: both;
        width: 100%;
    }

    &__submenulink {
        font-family: $fontFamily;
        font-size: 1rem;
        margin: 0 0.5rem;
        line-height: 2rem;
        text-decoration: none;
        white-space: nowrap;
    }

    &__submenulink:hover {
        color:$cAccent;
    }

    &__mainmenuitem:hover > &__submenulist,
    &__submenulist:hover,
    &__submenulist:focus {
        visibility: visible;
        opacity: 1;
        display: block;
    }

    &__appendix {
        float:right;
        margin: 0 1rem 0 0;
        color: #ffffff;
    }

    &__appendixlink {
        color:#ffffff;
        font-family: $fontFamilyRegular;
        font-size: 1rem;
        line-height: 2rem;
        text-decoration: underline;
    }

    &__appendixlink:hover {
        text-decoration: none;
    }
    &__appendixicon {
        position: relative;
        top:2px;
        margin-right:6px;
    }
}
</style>
